import fireApp from '../fireConfig.js'

export function Registrar(reg) {
        
    var result = {
        estado: false,
        mensajes: [],
    }

    if (reg.nombre == null) {
        result.mensajes.push('Ingrese un nombre ')
    }

    if (reg.apellido == null) {
        result.mensajes.push('Ingrese un apellido ')
    }

    if (!validateEmail(reg.mail)) {
        result.mensajes.push('Ingrese un E-mail ')
    }

    if (result.mensajes.length > 0) {
        return result
    } 

    var data = {
        nombre: reg.nombre,
        apellido: reg.apellido,
        telefono: reg.telefono,
        mail: reg.mail,
        empresa: reg.empresa,
        perfil: reg.perfil,
        comprador: reg.comprador,
        vendedor: reg.vendedor,
        origen: reg.origen,
    };  

    var regRef = fireApp.database().ref().child('/website/registrados');
    regRef.push(data);

    result.estado = true;

    return result

}

export function Suscribir(mail) {
    var result = {
        estado: false,
    }
    
    if (!validateEmail(mail)) {
        return result;
    }

    var susRef = fireApp.database().ref().child('/website/suscriptos');
    susRef.push(mail)

    result.estado = true;

    return result
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}


// WEBPACK FOOTER //
// ./E:/dev/repos/wpo_site/src/services/website/website.service.js